import filter from "lodash/filter";

import { poiTypes } from "../../../../server/lib/open-planet/poiTypes";
import constants from "../constants";

const _ = { filter };

function nearbyPois(state = {
  active: null,
  pois: [],
}, action) {
  switch (action.type) {
    case constants.FETCH_POI_DONE: {
      return {
        active: { ...action.data },
        pois: {},
      };
    }
    case constants.HOVER_PLACE: {
      const active = action.data && Object.keys(action.data).length > 0 ?
        action.data : state.active;
      return {
        active: { ...active },
        pois: { ...state.pois },
      };
    }
    case constants.FETCH_POI: {
      return {
        active: {},
        pois: {},
      };
    }
    case constants.FETCH_NEARBY_DONE: {
      const { nearby, id } = action.data;

      const filteredNearby = _.filter(nearby, (n) => (
        n.poiType !== poiTypes.info.name &&
        n.poiType !== poiTypes.transport.name &&
        n.poiType !== poiTypes.festivals_events.name
      ));

      return {
        active: { ...state.active },
        pois: {
          ...state.pois,
          [id]: filteredNearby.slice(1, 5),
        },
      };
    }
    default: {
      return state;
    }
  }
}

export default nearbyPois;



// WEBPACK FOOTER //
// ./assets/pois/reducers/nearbyPois.js